import React from 'react'
import PropTypes from 'prop-types'

import CircleButton from '../CircleButton/CircleButton'

function stateToColor(state) {
  switch (state) {
    case 'introduced':
      return 'yellow'
    case 'completed':
      return 'green'
    case 'highlighted':
      return 'purple'
    default:
      // neutral or unintroduced
      return 'white'
  }
}

function SkillButton({ size = 10, state = 'neutral', label = 'A', onClick = () => {}, loading, className = 'mt-1 mr-1' }) {
  return (
    <CircleButton
      size={size}
      color={stateToColor(state)}
      onClick={onClick}
      data-cy="skill-button"
      className={className}
      label={label}
      loading={loading}
    />
  )
}

SkillButton.sizes = CircleButton.sizes
SkillButton.states = ['neutral', 'unintroduced', 'introduced', 'completed', 'highlighted']

SkillButton.propTypes = {
  id: PropTypes.string,
  state: PropTypes.oneOf(SkillButton.states),
  label: PropTypes.string,
  size: CircleButton.propTypes.size,
  onClick: CircleButton.propTypes.onClick,
  loading: CircleButton.propTypes.loading,
  className: PropTypes.string
}

export default SkillButton
